/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { forgetSessionsFromAnotherAuthority } from './app/factories/token-authority';
import { environment } from './environments/environment';

// Before the OIDC library reads its configuration: a session kept from another login server would win over the
// server this build signs in with, and sign-in would stop at "Issuer mismatch" (dev moved to auth.breecelab.work,
// 27 Oct 2026). Storage can be unavailable (privacy settings); then there is nothing kept to remove.
try {
  forgetSessionsFromAnotherAuthority(sessionStorage, environment.authority);
} catch { }

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
